import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-engaged-or-vacant',
  templateUrl: './our-engaged-or-vacant.component.html',
  styleUrls: ['./our-engaged-or-vacant.component.scss']
})
export class OurEngagedOrVacantComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
